import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryCreateDropdownListProps,
  IInventoryCreateDropdownListResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export type IInventoryCatalogueTypes =
  | "FLAVOUR"
  | "BRAND"
  | "FORM"
  | "COLOR"
  | "ANIMAL_TYPE"
  | "TAGS"
  | "BREEDSIZE"
  | "AGERANGE";

export const useInventoryProductCatalogueDropdownItemCreateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterParams: IInventoryCreateDropdownListProps, catalogueType: IInventoryCatalogueTypes) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${INVENTORY_MODULE?.PRODUCT_CATALOGUE_DROPDOWN_CREATE?.baseURL}${catalogueType}/`, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryCreateDropdownListResponse>) => {
            if (res.data.status === true) {
              return { status: true, message: "batch" };
            } else {
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "batch_not_created" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
